export interface ClientData {
    clientBusinessName: string
    clientId: string
    ssnOrEIN: string
    expireDate?: string
    needAccept: boolean
}
export interface ClientsData {
    clients: ClientData[]
}

export enum AccountantAccountSwitcherMode {
    ONBOARDING, PROFILE
}

export interface IClientResponse {
    businessName?: string,
    customerExternalId: string,
    expirationDate?: string,
    firstName: string,
    lastName: string,
    status: string,
    ein?: string,
    ssn?: string,
}
